import normal from "./normal";
export default {
  normal
};
